import { render, staticRenderFns } from "./CommercialRemarkNotification.vue?vue&type=template&id=11556acc"
import script from "./CommercialRemarkNotification.vue?vue&type=script&lang=ts"
export * from "./CommercialRemarkNotification.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./CommercialRemarkNotification.vue?vue&type=style&index=0&id=11556acc&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports